export default __webpack_public_path__ + "742ed9df586ed17fff049b878e544b94.svg";